import { startBookingFlow, storeSlotDateView, updateBookingFlow } from "./api";

export const mutations = {
  start: startBookingFlow,
  update: updateBookingFlow,
  storeSlotDateView,
};
